<div class="modal-header">
  <h4 class="modal-title">Upload Job Description</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="onCancel()" ></button>
</div>
<div class="modal-body">
              <div class="d-flex align-items-center flex-wrap gap-2">
    <p>This position does not have a job description associated with it. To help us better understand the role and ensure accurate processing, please upload a job description for this position.</p>
    <label class="btn btn-sm btn-primary btn-file" style="margin-right: 0.25rem;">
      <span class="fa fa-cloud-upload"></span> Upload Job Description <input type="file" hidden (change)="onUploadJobDescriptionFileChange($event)" accept=".pdf,.doc,.docx">
    </label>
    <span class="fa fa-info-circle text-muted"
        style="cursor: pointer; font-size: 1rem; margin-left: -4px; margin-right: 8px;"
        [ngbTooltip]="'Only .PDF or .doc/.docx files are supported'"
        container="body"
        placement="top">
        </span>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger" (click)="onCancel()">Not currently available</button>
</div>
